var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotNet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#512BD4",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.0522 168.943C21.8155 168.943 19.9143 168.212 18.3486 166.749C16.7829 165.248 16 163.466 16 161.402C16 159.301 16.7829 157.5 18.3486 155.999C19.9143 154.499 21.8155 153.748 24.0522 153.748C26.3262 153.748 28.246 154.499 29.8118 155.999C31.4147 157.5 32.2162 159.301 32.2162 161.402C32.2162 163.466 31.4147 165.248 29.8118 166.749C28.246 168.212 26.3262 168.943 24.0522 168.943Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M113.467 167.705H98.9285L60.625 108.387C59.6558 106.886 58.8539 105.328 58.2205 103.715H57.8848C58.1831 105.441 58.3322 109.137 58.3322 114.802V167.705H45.4707V87H60.96L97.9781 144.912C99.5439 147.314 100.55 148.964 100.998 149.865H101.221C100.849 147.726 100.662 144.106 100.662 139.002V87H113.467V167.705Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M176.098 167.705H131.084V87H174.309V98.3688H144.393V121.218H171.961V132.53H144.393V156.393H176.098V167.705Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M240.071 98.3688H217.033V167.705H203.724V98.3688H180.742V87H240.071V98.3688Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotNet);
export default __webpack_public_path__ + "static/media/DotNet.cd39e186d56311da51d7a4843277fce4.svg";
export { ForwardRef as ReactComponent };